// extracted by mini-css-extract-plugin
module.exports = {"rangeBlock":"RangeSlidersBlock_rangeBlock__okniG","rangeFilterBox":"RangeSlidersBlock_rangeFilterBox__17rr1"};